export default __webpack_public_path__ + "static/logoHead-19f874d2c01a169f8ac52e895a222b0f.png";